import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import PrintTools from '@/components/admin/PrintTools';
import * as Routes from '@/modules/routes';
import NodeCrumbs from '../../shared/ProgramTree/NodeCrumbs';
import NodeTabs from '../../shared/ProgramTree/NodeTabs';
import { lessonPages } from '../../shared/ProgramTree/contentPages';
import { useProgramSummary } from '../../shared/ProgramTree/usePrograms';
import SPAPageHeader from '../../shared/SPAPageHeader';
import { useSPAUser } from '../../shared/SPAUser';
import {
  lessonPrintToolsPath, programLessonsPath, unitEditPath, useContentMount,
} from '../contentMount';
import ProgramNavRail from '../ProgramLessons/ProgramNavRail';
import { takeIdml } from './pendingIdml';
import useStudentTextStylesheet from './useStudentTextStylesheet';

// AIDEV-NOTE: The print tools (compare + pour) on a lesson, the SPA counterpart of the legacy
// sections page's Print Tools tab. The tool is the shared admin/PrintTools component with the
// lesson fixed; this page only frames it. The container is wider than the other content pages
// (the legacy page lifts its width cap too) so the side-by-side pour has room.
const PrintToolsPage = () => {
  const { lessonId, programId } = useParams<{ lessonId: string; programId: string }>();
  const pid = Number(programId);
  const lid = Number(lessonId);
  const mount = useContentMount();
  const { showPrintTools } = useSPAUser();
  const {
    color, isLoading: isLoadingTitle, science, title: programTitle,
  } = useProgramSummary(pid);
  const [initialFile] = useState(takeIdml);
  useStudentTextStylesheet();

  return (
    <div className="tw-min-h-screen tw-bg-spa-bg tw-text-spa-on-bg">
      {mount === 'spa' && (
        <ProgramNavRail
          isLoadingTitle={isLoadingTitle}
          lessonId={lid}
          programColor={color}
          programId={pid}
          programTitle={programTitle}
        />
      )}
      <div className="tw-mx-auto tw-max-w-[125rem] tw-px-6 tw-py-4">
        <NodeCrumbs
          lessonId={lid}
          programId={pid}
          programTitle={programTitle}
          toLesson={id => lessonPrintToolsPath(pid, id, mount)}
          toProgram={id => programLessonsPath(id, mount)}
          toUnit={id => unitEditPath(pid, id, mount)}
        />
        <SPAPageHeader title="Print Tools" />
        <div className="tw-mb-5 tw-border-0 tw-border-b tw-border-solid tw-border-spa-border">
          <NodeTabs label="Lesson pages" pages={lessonPages(lid, pid, science, showPrintTools)} />
        </div>
        <PrintTools
          analyzePath={Routes.analyze_admin_print_tools_path()}
          initialFile={initialFile}
          lessonId={lid}
          programId={pid}
          workspaceLayout="split"
        />
      </div>
    </div>
  );
};

export default PrintToolsPage;
